import React from 'react';
import PropTypes from 'prop-types';

// Components
import ModalWrapper from './modal-wrapper';
import ModalControls from 'Webapp/shared/app/components/modal-controls';
import {
  MODAL_THEMES,
  MODAL_MODIFIERS,
  MODAL_WINDOW_SIZES,
} from 'ComponentLibrary/modals/modal';
import Button, { StyleVariations } from 'Webapp/shared/app/components/button';
import WebLink from '../components/web-link';
import withT from 'ComponentLibrary/hocs/withT';

import connector from 'Utils/connector';
import connectModal from 'Webapp/shared/app/connectors/connectModal';

function DoNotSellModal({ dismissModal, t }) {
  return (
    <ModalWrapper
      name="do-not-sell"
      className="do-not-sell-modal"
      modalTheme={MODAL_THEMES.WINDOW}
      modifier={MODAL_MODIFIERS.HAS_FIXED_HEADER_AND_CONTROLS}
      size={MODAL_WINDOW_SIZES.LARGE}
    >
      <div className="modal__header do-not-sell-modal__header">
        <h1 className="ui-text--page-title">Do Not Sell Notice</h1>
      </div>
      <div className="modal__content do-not-sell-modal__content">
        <p className="ui-text--body">
          Welcome to Flipboard’s portal for opting out of the sale/sharing of
          your personal information for targeted advertising. Residents of
          certain states have the right to opt-out of the sale of personal
          information, as well as the sharing of personal information for
          targeted advertising.
        </p>
        <p className="ui-text--body">
          You are not currently logged into a Flipboard account.{' '}
        </p>
        <p className="ui-text--body">
          If you have a Flipboard account, on the website or on mobile app you
          can log into your account and navigate to Privacy Settings to opt-out
          of the sale of your personal information. This will opt you out of
          sale for all personal information (not just your online identifiers).
          If you do not have a Flipboard account and only visit{' '}
          <WebLink href="https://flipboard.com">Flipboard.com</WebLink>, the
          information we have about you is limited to online identifiers (e.g.
          cookie IDs, IP addresses, etc.). We do not sell or share your
          information when you are browsing anonymously on our website. You may
          opt out of sale when applicable using the DAA CCPA opt-out tool at{' '}
          <WebLink href="https://www.privacyrights.info/">
            https://www.privacyrights.info/
          </WebLink>
          . You may also be able to configure your mobile device privacy or
          advertising settings, including by selecting “limit ad tracking” on an
          iOS device or “opt out of interest-based ads” on an Android.
        </p>
      </div>
      <ModalControls fixedControls onDismiss={dismissModal}>
        <Button
          name="close"
          label={t('close')}
          styleVariation={StyleVariations.SECONDARY}
          onClick={dismissModal}
        />
      </ModalControls>
    </ModalWrapper>
  );
}

DoNotSellModal.propTypes = {
  t: PropTypes.func.isRequired,
  dismissModal: PropTypes.func.isRequired,
};

export default connector(connectModal)(withT(DoNotSellModal));
